module.exports = "../../static/img/RolVzroslogo.73c85d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about_us_main/RolVzroslogo.jpg
// module id = ItpX
// module chunks = 1